import React, { useRef, useState } from "react"
import qs from 'qs';
import Slider from "react-slick"
import SliderItem from "./SliderItem"
import { useDispatch, useSelector } from "react-redux"
import { updateUserAnswer } from "../../reducers/userAnswersReducer"
import SliderDot from "./SliderDot"
import { useNavigate } from "react-router-dom";
import QuestionsSliderFooter from "./QuestionsSliderFooter";
import { usePrefersReducedMotion } from "../../../lib/a11y/usePrefersReducedMotion";



const QuestionsSlider =() => {
    const questions = useSelector(state => state.questions)
    const userAnswers = useSelector(state => state.userAnswers.items)
    const version = useSelector(state => state.version)
    const navigate = useNavigate();
    const dispatch = useDispatch()
    let sliderRef = useRef(null)
    // Wer im System weniger Bewegung wuenscht, bekommt den Folienwechsel ohne
    // Animation (#178).
    const wenigerBewegung = usePrefersReducedMotion()
    // Welche Folie sichtbar ist, entscheidet, welche Radios per Tab erreichbar
    // sind — die uebrigen Folien versteckt react-slick per aria-hidden (#178).
    const [aktuell, setAktuell] = useState(0)

    const { order, items } = questions
    const maxSlides = order.length

    const settings = {
        dots: true,
        swipe: false,
        arrows: false,
        infinite: false,
        // Keine eigene Tastatursteuerung des Sliders: ein Pfeil auf der
        // Ueberschrift der naechsten Frage blaetterte sonst an ihr vorbei,
        // obwohl sie offen war. Weiter geht es nur ueber eine Antwort oder die
        // Punktleiste, die offene Fragen sperrt (Spec 4.2.2).
        accessibility: false,
        speed: wenigerBewegung ? 0 : 500,
        beforeChange: (_, naechste) => setAktuell(naechste),
        slidesToShow: 1,
        slidesToScroll: 1,
        sliderRef,
        appendDots: dots => <QuestionsSliderFooter dots={dots} />,
        customPaging: i => <SliderDot
            index={i}
            order={order}
            userAnswers={userAnswers}
            onClickDot={onClickDot}
        />
    }

    const onClickDot = index => {
        sliderRef.slickGoTo(index)
    }

    // Der Pfeil markiert eine Stufe: gespeichert, aber noch nicht weiter.
    const onWaehle = questionId => val => {
        dispatch(updateUserAnswer({
            id: questionId,
            val: val
        }))
    }

    const onSelectAnswer = (index, questionId) => (val) => {
        dispatch(updateUserAnswer({
            id: questionId,
            val: val
        }))

        if(index === maxSlides -1) {
            // v zuerst: die Version des Stands, damit der Link auch nach
            // erneutem Einfrieren das Ergebnis von damals zeigt (Spec 2026-10-06).
            const queryString = qs.stringify({
                v: version,
                ...userAnswers,
                [questionId]: val
            }, { skipNulls: true })

            navigate(`/ergebnisse/?${queryString}`)
        } else {
            sliderRef.slickGoTo(index + 1)
        }
    }

    return (
        <div>
            <div className="jm-slide">
                <Slider 
                    ref={slider => {
                        sliderRef = slider
                    }}
                    { ...settings}
                >
                    {order.map((itemId, index) => (
                        <SliderItem
                            key={itemId}
                            item={items[itemId]}
                            current={index + 1}
                            max={maxSlides}
                            value={userAnswers[itemId]}
                            aktiv={index === aktuell}
                            onSelectAnswer={onSelectAnswer(index, itemId)}
                            onWaehle={onWaehle(itemId)}
                        />
                    ))}
                </Slider>
            </div>


        </div>
    )
}

export default QuestionsSlider